"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../utils");
var _Logo = require("../Logo");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeaderLogoMobile = (0, _styledComponents.default)(_Logo.Logo)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 26px;\n"])));
var HeaderLogoDesktop = (0, _styledComponents.default)(_Logo.Logo)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 30px;\n"])));
var Logo = function Logo(props) {
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  return isMobile ? /*#__PURE__*/_react.default.createElement(HeaderLogoMobile, props) : /*#__PURE__*/_react.default.createElement(HeaderLogoDesktop, props);
};
exports.Logo = Logo;